import { Component, Injector, Input } from '@angular/core';
import { CountyLabel } from 'app/core/helpers/constants';
import { County } from 'app/core/helpers/enums';
import { BaseFilterComponent } from 'app/core/filter-system';

@Component({
  selector: 'app-sidebar-location-filter',
  templateUrl: './sidebar-location-filter.component.html',
  styleUrls: ['./sidebar-location-filter.component.scss']
})
export class SidebarLocationFilterComponent extends BaseFilterComponent<number[]> {
  readonly filterId = 'locations';

  @Input() isMobile: boolean;

  counties = Object.values(County).filter(v => typeof v === 'number' && v !== County.WholeCountry) as County[];
  locationSelection: { [key: number]: boolean } = {};
  CountyLabel = CountyLabel;

  constructor(injector: Injector) {
    super(injector);
  }

  getQueryParamKey(): string {
    return 'locations';
  }

  parseQueryParam(rawValue: string): void {
    this.counties.forEach(c => (this.locationSelection[c] = false));
    rawValue.split(',').forEach(l => {
      this.locationSelection[+l] = true;
    });
  }

  buildFilterValue(): number[] {
    return Object.entries(this.locationSelection)
      .filter(([_, isSelected]) => isSelected)
      .map(([key]) => Number(key) as County);
  }

  clearSelection(): void {
    this.counties.forEach(c => (this.locationSelection[c] = false));
  }

  checkLocation(): void {
    this.onFilterChange();
  }
}
